




































import {Component, Prop, Vue} from 'vue-property-decorator';
import BlankLoader from '@/components/common/BlankLoader.vue';
import CollapsibleTable from '@/components/common/CollapsibleTable.vue';
import DataTable from '@/components/common/DataTable.vue';
import DataFilter from '@/components/common/DataFilter.vue';
import {asyncScheduler, combineLatest, from} from 'rxjs';
import {filterMatchColumns} from '@/helpers';
import {ratingApi} from '@/api/RatingApi';
import {
  filter,
  map,
  switchMap,
} from 'rxjs/operators';
import {forumApi} from '@/api/ForumApi';
import {
  generateLangSubscriptions,
  observeFieldAsUIInput,
  observeProp,
  watchAsLoadedObservable,
} from '@/components/observe';

@Component<UserTournaments>({
  components: {
    DataFilter,
    DataTable,
    CollapsibleTable,
    BlankLoader,
  },
  subscriptions() {
    const userProfile$ = observeProp(this, 'userId').pipe(
      filter((x: any) => !!x),
      switchMap((x) => from(ratingApi.getUserProfile$(x), asyncScheduler)),
    );

    return Object.assign(generateLangSubscriptions(observeProp<string>(this, 'lang')), {
      tournaments: combineLatest(
        userProfile$,
        observeFieldAsUIInput(this, 'tournamentsFilter'),
      ).pipe(
        map(([userProfile, tournamentFilter]: any) =>
          userProfile.tournaments.filter((x: any) => this.filterMatch(x, tournamentFilter))),
        map((x: any) => x.map((y: any) => Object.assign(y, {
          forum_thread_link: forumApi.getForumThreadUrl(y.forum_topic_id),
        }))),
      ),
      isTournamentsLoaded: watchAsLoadedObservable(this, 'tournaments'),
    });
  },
})
export default class UserTournaments extends Vue {
  public tournamentColumns = [
    {name: 'title', title: 'title', width: '80%'},
    {name: 'start', title: 'start', width: '10%'},
    {name: 'end', title: 'end', width: '10%'},
  ];
  public tournamentsFilter = '';

  @Prop() public userId!: number;
  @Prop() public lang!: number;
  @Prop() public isLoading!: boolean;

  public filterMatch(tournament: any, tournamentFilter: any) {
    return filterMatchColumns(tournament, tournamentFilter, [
      'title',
      'start_time',
      'end_time',
    ]);
  }
}
